// Bouwt WolforkQuizConfig uit section blocks (content) + quiz-logic.js (structuur).

(function () {
  const CONTENT_KEYS = [
    'section_nl', 'sub_label_nl', 'label_nl', 'lead_nl', 'hint_nl', 'placeholder_nl',
    'panel_label_nl', 'fallback_before_nl', 'fallback_link_nl', 'fallback_after_nl',
    'expert_tip_nl', 'info_nl', 'consent_nl', 'submit_label_nl', 'background_mobile', 'background_desktop',
  ];

  function coerceOptionValue(raw, fallback) {
    if (raw === '' || raw == null) return fallback;
    const n = Number(raw);
    if (!Number.isNaN(n) && String(raw).trim() === String(n)) return n;
    return raw;
  }

  function mergeOptions(blockOptions, logicOptions) {
    if (!blockOptions || !blockOptions.length) return logicOptions || [];
    if (!logicOptions || !logicOptions.length) return blockOptions;
    return blockOptions.map((opt, i) => ({
      ...(logicOptions[i] || {}),
      ...opt,
      value: opt.value != null && opt.value !== '' ? coerceOptionValue(opt.value, logicOptions[i]?.value) : logicOptions[i]?.value,
      image: opt.image || logicOptions[i]?.image || '',
    }));
  }

  function mergeQuestionContent(content, logicEntry, defaults) {
    const merged = { id: content.id, ...logicEntry };
    const base = defaults || {};

    CONTENT_KEYS.forEach((key) => {
      const fromBlock = content[key];
      if (fromBlock != null && String(fromBlock).trim() !== '') {
        merged[key] = fromBlock;
      } else if (base[key] != null && merged[key] == null) {
        merged[key] = base[key];
      }
    });

    merged.options = mergeOptions(
      content.options && content.options.length ? content.options : null,
      base.options || logicEntry.options,
    );
    return merged;
  }

  function buildFromBlocks(blockContent) {
    const logic = window.WolforkQuizLogic;
    if (!logic) return { questions: [] };

    const blocks = (blockContent || []).filter((c) => c && c.id);

    if (!blocks.length) {
      return {
        questions: logic.defaultOrder
          .map((id) => {
            const entry = logic.byId[id];
            if (!entry) return null;
            return mergeQuestionContent({ id }, entry, logic.defaultContent[id]);
          })
          .filter(Boolean),
      };
    }

    const questions = blocks
      .map((content) => {
        const entry = logic.byId[content.id];
        if (!entry) return null;
        return mergeQuestionContent(content, entry, logic.defaultContent[content.id]);
      })
      .filter(Boolean);

    return { questions };
  }

  window.WolforkQuizConfig = {
    build(blockContent) {
      return buildFromBlocks(blockContent);
    },
    // Backwards compat: oude code die .questions direct leest vóór init
    get questions() {
      return buildFromBlocks([]).questions;
    },
  };
})();
